<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        :height="height" :class="classes" class="fill-current">
        <path  d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8.41l2.54 2.53a1 1 0 0 1-1.42 1.42L11.3 12.7A1 1 0 0 1 11 12V8a1 1 0 0 1 2 0v3.59z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>